import { Field, Form, Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "react-bootstrap"
import { FileField } from "../../components/Fields/FileField"
import GenericFormError from "../../components/Fields/GenericFormError"
import { InputField } from "../../components/Fields/InputField"
import { transformErrorForForm } from "../../components/Fields/utils"
import { useUploadFile } from "../../hooks/filessystems"

type UploadFormProps = {
  isOpen: boolean
  toggle?: () => void
  onClosed: () => void
  idFolder: number
  onUpload?: () => void
}

export default function UploadFileModal({ isOpen, toggle, onClosed, idFolder, onUpload }: UploadFormProps) {
  const { mutateAsync: uploadFile } = useUploadFile(idFolder)

  return (
    <Formik<{ file: File | undefined; description: string }>
      initialValues={{ file: undefined, description: "" }}
      onSubmit={(values, actions) => {
        return uploadFile(values)
          .then(() => {
            toggle?.()
            onUpload?.()
          })
          .catch((err) => {
            console.error(err)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            actions.setErrors(transformErrorForForm(err) as any)
          })
      }}
    >
      {({ handleSubmit, values, errors, isSubmitting }) => (
        <Modal show={isOpen} onHide={toggle} onExited={onClosed}>
          <Form onSubmit={handleSubmit}>
            <ModalHeader className="flex-row justify-content-between bg-primary text-white">
              <span>Caricamento File</span>
            </ModalHeader>
            <ModalBody>
              <Field required component={FileField} name="file" type="file"></Field>
              <Field component={InputField} name="description" label={"Descrizione"} type="textarea" textarea />
              <GenericFormError errors={errors} messageParser={messageParser} showError></GenericFormError>
            </ModalBody>
            <ModalFooter>
              {isSubmitting && <Spinner variant="primary" />}
              {!isSubmitting && (
                <button className="btn btn-primary" type="submit" disabled={!values.file}>
                  Carica
                </button>
              )}
            </ModalFooter>
          </Form>
        </Modal>
      )}
    </Formik>
  )
}

const messageParser = (error: any) => {
  if (typeof error === "object") {
    const failingRows = Object.keys(error).filter((key) => Object.keys(error[key]).length > 0)
    if (failingRows.length > 0) {
      return (
        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
          <p>Errore nel caricamento del file:</p>
          <ul>
            {failingRows.map((key) => (
              <li key={key}>
                <strong>{key}</strong>: {JSON.stringify(error[key])}
              </li>
            ))}
          </ul>
        </div>
      )
    }
    return null
  }
}
